import JobsthemeColorsData from "../../js/jobsthemeColorsData";
import { useSelector } from "react-redux";
import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
export default () => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state.app.userData.userData);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const {
    data: jobsApplied,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
    error,
  } = useInfiniteQuery({
    queryKey: ["JobsAppliedList", userData?.talent?.id],
    queryFn: ({ pageParam = 1 }) =>
      axios
        .get(`${baseURL}/api/v2/applied-jobs`, {
          params: {
            talent_id: userData?.talent?.id,
            page: pageParam,
          },
        })
        .then((res) => res.data.data),
    getNextPageParam: (lastPage) => {
      return lastPage.has_more_pages ? lastPage.current_page + 1 : undefined;
    },
  });
  const handleJobClick = (id) => {
    navigate(`/job-details/${id}`);
  };

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading Job Applies: {error.message}
        </p>
      </div>
    );
  }
  return {
    isLoading,
    jobsApplied,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    handleJobClick,
    JobsthemeColorsData,
  };
};
